import {useComponents} from "../../framework/components/_components";
import {EventBus} from "./modules/event-bus";
import {useHeader} from "./modules/header";
import * as AOS from 'aos';
main();

function main() {
    useComponents();
    useHeader();
    AOS.init({
        once: true,
    });
}

document.addEventListener('DOMContentLoaded', () => {
    (<any>window).hdEventBus = new EventBus();
});
